import type { Glossary } from './get-glossary-api';

export const UpdateGlossary= Symbol('UpdateGlossary');

/**
* 更新术语表
* @description 用于更新术语表
* @param params 术语表
 */
export interface UpdateGlossary {
    updateGlossary(params: Glossary): Promise<void>;
}
